import { render } from "./App.vue?vue&type=template&id=85b7401e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=85b7401e&lang=scss"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__